import { useState } from 'react';
import { ROL_ADI, tarihSaatGoster } from '@nero/shared';
import { api, useEylem } from '../lib/veri.js';
import { useOturum } from '../lib/oturum.js';
import { useBildirim } from '../lib/bildirim.js';
import { Kart, KartBaslik, SayfaBaslik, UyariSerit } from '../bilesenler/temel.js';
import { Girdi, SecenekSerit } from '../bilesenler/form.js';
import { temayiOku, temayiYaz } from '../lib/tema.js';
import type { Tema } from '../lib/tema.js';
import { Simge } from '../bilesenler/Simge.js';

export function Ayarlar() {
  const { kullanici, cikisYap } = useOturum();
  const bildir = useBildirim();
  const [mevcut, setMevcut] = useState('');
  const [yeni, setYeni] = useState('');
  const [tekrar, setTekrar] = useState('');
  const [tema, setTema] = useState<Tema>(() => temayiOku());

  const { yurut, calisiyor, hata } = useEylem(async () => {
    await api.gonder('/oturum/sifre', { mevcut, yeni });
    bildir('Şifreniz değiştirildi');
    setMevcut(''); setYeni(''); setTekrar('');
  });

  const uyumsuz = tekrar.length > 0 && yeni !== tekrar;
  const gecerli = mevcut.length > 0 && yeni.length >= 8 && yeni === tekrar;

  return (
    <div className="sayfa" style={{ maxWidth: 720 }}>
      <SayfaBaslik baslik="Ayarlar" alt="Hesabınız ve uygulama bilgileri" />

      <div className="sutun" style={{ gap: 'var(--b5)' }}>
        <Kart>
          <KartBaslik baslik="Hesap" />
          <div className="kart-govde">
            <dl className="tanim">
              <dt>Ad soyad</dt><dd>{kullanici?.ad_soyad}</dd>
              <dt>Kullanıcı adı</dt><dd>{kullanici?.kullanici_adi}</dd>
              <dt>Rol</dt><dd>{kullanici ? ROL_ADI[kullanici.rol] : '—'}</dd>
              <dt>Son giriş</dt><dd>{kullanici?.son_giris_at ? tarihSaatGoster(kullanici.son_giris_at) : '—'}</dd>
            </dl>
          </div>
        </Kart>

        <Kart>
          <KartBaslik baslik="Şifre değiştir" />
          <div className="kart-govde sutun">
            <Girdi etiket="Mevcut şifre" type="password" value={mevcut} onChange={setMevcut} autoComplete="current-password" />
            <Girdi etiket="Yeni şifre" type="password" value={yeni} onChange={setYeni} autoComplete="new-password"
              ipucu="En az 8 karakter" />
            <Girdi etiket="Yeni şifre (tekrar)" type="password" value={tekrar} onChange={setTekrar}
              autoComplete="new-password" hata={uyumsuz ? 'Şifreler eşleşmiyor' : null} />
            {hata && <UyariSerit ton="kritik">{hata}</UyariSerit>}
            <div>
              <button className="btn btn-birincil" onClick={() => void yurut(undefined as never)} disabled={!gecerli || calisiyor}>
                {calisiyor ? 'Değiştiriliyor…' : 'Şifreyi değiştir'}
              </button>
            </div>
          </div>
        </Kart>

        <Kart>
          <KartBaslik baslik="Görünüm" />
          <div className="kart-govde sutun">
            <SecenekSerit
              deger={tema}
              secenekler={[
                { deger: 'koyu' as Tema, ad: 'Koyu tema' },
                { deger: 'acik' as Tema, ad: 'Açık tema' },
              ]}
              onChange={(t) => { setTema(t); temayiYaz(t); }}
            />
            <div style={{ fontSize: 'var(--p-12)', color: 'var(--metin-3)' }}>
              Tema bu cihazda saklanır; diğer cihazlarınızı etkilemez.
            </div>
          </div>
        </Kart>

        <Kart>
          <KartBaslik baslik="Oturum" />
          <div className="kart-govde">
            <button className="btn btn-ikincil" onClick={() => void cikisYap()}>
              <Simge ad="cikis" className="simge" /> Çıkış yap
            </button>
          </div>
        </Kart>

        {/* DERLEME DAMGASI — "güncellendi mi?" sorusunu bakarak çözer.
            Damga, arayüzün derlendiği andır. Teslim edilen paketten
            eskiyse kurulum yapılmamış demektir. */}
        <p style={{ fontSize: 'var(--p-12)', color: 'var(--metin-3)', textAlign: 'center' }}>
          Nero Pro · NeroPerformance işletme yönetim sistemi
          <br />
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>
            Arayüz derlemesi: {__NERO_DERLEME__}
          </span>
        </p>
      </div>
    </div>
  );
}
